import notfound from "./notfound";

export default {
  notfound,
};
